qtySubmit.addEventListener("click", () => {
  if (licCalcQuantity.validity.rangeUnderflow) {
    licCalcQuantity.setCustomValidity("A license comes with at least 3 seats.");
    $("#licCalcQuantity").val($("#licCalcQuantity").attr("min"));
  } else if (licCalcQuantity.validity.rangeOverflow) {
    licCalcQuantity.setCustomValidity(
      "If you need more than 150 seats, please contact us."
    );
    $("#licCalcQuantity").val($("#licCalcQuantity").attr("max"));
  } else {
    licCalcQuantity.setCustomValidity("");
  }
});

var fixedBtn = $("#standardPurchaseBtn");
var floatBtn = $("#floatPurchaseBtn");

function shBtn(state, whichBtn) {
  if (state == "show") {
    whichBtn.show();
  } else {
    whichBtn.hide();
  }
}

var prices = {
  GCode: {
    price: 60,
    seatprice: 15,
    fixed: "5977694535719",
    float: "48847453094056",
    seat: "36333506986152",
  },
  DSP: {
    price: 120,
    seatprice: 30,
    fixed: "6531596714023",
    float: "39573754478760",
    seat: "31152935043117",
  },
  Galvo: {
    price: 150,
    seatprice: 37.5,
    fixed: "42403940597928",
    float: "48848609149096",
    seat: "49013093695656",
  },
  DSPGalvo: {
    price: 210,
    seatprice: 52.5,
    fixed: "42404059414696",
    float: "48847238332584",
    seat: "49013158936744",
  },
  Core: {
    price: 99,
    seatprice: 25,
    fixed: "49645168591016",
    float: "49645277937832",
    seat: "49645992870056"
  },
  Pro: {
    price: 199,
    seatprice: 50,
    fixed: "49645242876072",
    float: "49645400096936",
    seat: "49645885391016"
  },
  // --- MillMage -----------------------------------------------------------
  // Variant IDs verified against the live products. Prices confirmed too:
  // Core $99 / Pro $199 (MM-CORE, MM-PRO), seats $25 / $50 (MM-ADD-CORE-NEW,
  // MM-ADD-PRO-NEW), floating $274 / $549 which is the 10-seat total under the
  // same formula — so quote and cart agree at every seat count.
  // The seat products must be the "for New Key" ones: the calculator builds a
  // cart containing a new licence plus its extra seats in a single order.
  MillMageCore: {
    price: 99,
    seatprice: 25,
    fixed: "53196683641000",
    float: "55975223918760",
    seat: "55595920228520"
  },
  MillMagePro: {
    price: 199,
    seatprice: 50,
    fixed: "55555651502248",
    float: "55975223263400",
    seat: "55596046123176"
  }
};

// #outputType printed the raw object key, which was fine while keys were single
// words but would render "MillMageCore". Anything not listed falls back to the
// key itself, preserving the old behaviour for GCode / DSP / Galvo / Core / Pro.
var typeLabels = {
  DSPGalvo: "DSP + Galvo",
  Core: "LightBurn Core",
  Pro: "LightBurn Pro",
  MillMageCore: "MillMage Core",
  MillMagePro: "MillMage Pro"
};

// ---- brand switch -------------------------------------------------------
// Used by the combined LightBurn + MillMage page. Everything here is inert if
// the page has no input[name="brand"], so the standalone LightBurn page keeps
// working exactly as before.
var brandInputs = $('input[name="brand"]');

function currentBrand() {
  return brandInputs.length ? brandInputs.filter(":checked").val() : null;
}

// Core/Pro radios stay brand-neutral; the brand turns them into a prices key.
function licenceKeyFor(lictype) {
  return currentBrand() === "MillMage" ? "MillMage" + lictype : lictype;
}

function applyBrand() {
  // standalone single-brand pages have no brand radios — leave them alone
  if (!brandInputs.length) return;

  var brand = currentBrand();

  // nothing below the picker is shown until a brand is chosen, so the page
  // can never display copy or a price for the wrong product
  if (!brand) {
    $("#brandContent").hide();
    $("#quoteSection").hide();
    return;
  }
  // The content animation is delayed on the FIRST reveal only, so the "select
  // an option" prompt can fade out before the page arrives. On a later switch
  // the prompt is already gone, so the delay would just feel sluggish. CSS
  // can't tell the two apart, hence this class: :hidden is true only before
  // the first show().
  var firstReveal = $("#brandContent").is(":hidden");
  $("#brandContent").show();
  $("#brandContent").toggleClass("is-first-reveal", firstReveal);

  $(".brandName").text(brand);

  $("[data-brand]").each(function () {
    $(this).toggle($(this).attr("data-brand") === brand);
  });

  $("a[data-href-lightburn]").each(function () {
    var href = $(this).attr(
      brand === "MillMage" ? "data-href-millmage" : "data-href-lightburn"
    );
    $(this).attr("href", href);
  });

  // a quote for the other brand would be stale and misleading
  $("#quoteSection").removeClass("is-stale").hide();
}

brandInputs.on("change", applyBrand);
applyBrand();

// A quote stays on screen until recalculated, and the purchase buttons keep
// the href from that calculation — so changing the version or the seat count
// left a stale price with buttons pointing at the previous product. Hide the
// quote on any change so what's shown always matches what's selected.
// (The brand switch already does this inside applyBrand.)
$('input[name="lictype"], #licCalcQuantity').on("change input", function () {
  // Don't hide the quote — any hide changes the layout and the page jumps.
  // Mark it stale instead: CSS dims it and disables the buttons, so the old
  // price is visibly out of date and can't be acted on, with nothing moving.
  $("#quoteSection").stop(true, true)
    .css({ opacity: "", height: "", marginBottom: "", paddingTop: "", paddingBottom: "" })
    .addClass("is-stale");
});


$("#qtyForm").on("submit", function (e) {
  // Without this the form submits normally and the page reloads,
  // discarding the quote. Present in the Dawn copy of this file but
  // missing from the version that came across to DigiFable.
  e.preventDefault();
  var seatQuantity = $("#licCalcQuantity").val();
  var lictype = licenceKeyFor($('input[name="lictype"]:checked').val());

  var pricing = prices[lictype];

  var constructFixedCartURL = `https://lightburnsoftware.com/cart/${pricing.fixed}:1`;
  var constructFloatCartURL = `https://lightburnsoftware.com/cart/${pricing.float}:1`;

  var price = pricing.price;
  if (seatQuantity > 3) price += (seatQuantity - 3) * pricing.seatprice;

  if (seatQuantity > 3)
    constructFixedCartURL += `,${pricing.seat}:${seatQuantity - 3}`;
  if (seatQuantity > 10)
    constructFloatCartURL += `,${pricing.seat}:${seatQuantity - 10}`;

  if (seatQuantity < 3) {
    $("#qtyMessage").text(
      "A standard license key comes with 3 seats by default"
    );

    $("#fixedOrFloatMessage").text("");
    //$('#licCalcQuantity').val(3);
    //fixed link: ""
    constructDspFixedCartURL = "";
    //float link: ""
    constructDspFloatCartURL = "";
    //GC fixed link: ""
    constructGcFixedCartURL = "";

    shBtn("hide", fixedBtn);
    shBtn("hide", floatBtn);
  } else if (seatQuantity < 10) {
    //between 3 and 10, yes fixed no floating
    $("#qtyMessage").text("");
    $("#fixedOrFloatMessage").text(
      "You can get a standard license.  A floating license has a 10 seat minimum."
    );

    shBtn("show", fixedBtn);
    shBtn("show", floatBtn);
  } else if (seatQuantity >= 10) {
    // 10 or more - yes fixed and yes floating
    $("#qtyMessage").text("");
    $("#fixedOrFloatMessage").text(
      "You can get either a standard license or a floating license!"
    );

    shBtn("show", fixedBtn);
    shBtn("show", floatBtn);
  } else {
    $("#qtyMessage").text("Error: Error");
  }

  //Display stuff in HTML
  $("#outputQuantity").text(seatQuantity);
  $("#outputType").text(typeLabels[lictype] || lictype);
  $("#outputPrice").text(`${price * 100}`.replace(/(..$)/, ".$1"));
  //modify button links

  $("#standardPurchaseLink").attr("href", constructFixedCartURL);
  $("#floatingPurchaseLink").attr("href", constructFloatCartURL);

  // Floating has a 10-seat minimum. Below that the option stays visible but
  // inert, with a tooltip explaining why, rather than disappearing. Dropping
  // the href is what makes the anchor non-navigable; tabindex keeps it
  // keyboard-reachable so the tooltip is available without a mouse.
  var floatLink = $("#floatingPurchaseLink");

  if (seatQuantity >= 10) {
    floatLink
      .removeClass("is-disabled")
      .removeAttr("aria-disabled")
      .removeAttr("data-tip")
      .removeAttr("tabindex")
      .attr("href", constructFloatCartURL);
  } else {
    floatLink
      .addClass("is-disabled")
      .attr("aria-disabled", "true")
      .attr("data-tip", "Floating licenses require a minimum of 10 seats")
      .attr("tabindex", "0")
      .removeAttr("href");
  }

  $("#quoteSection").stop(true, true)
    .css({ opacity: "", height: "", marginBottom: "", paddingTop: "", paddingBottom: "" })
    .removeClass("is-stale")
    .show();
});